import React from "react";
import { Link } from "react-router-dom";

function PersonalizeSimulationHome() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-Personalize-simulation">
      <div className="container d-flex flex-column align-items-center justify-content-center vh-45 w-100">
            <div className="row d-flex justify-content-center align-items-center my-auto text-center w-50">
                <div className="bg-white rounded-border py-3 border border-4 border-dark">
                    <div className="col-12 heading-font mb-3">
                        <h1>Personalize Simulation</h1>
                    </div>
                    <p>You now have the chance to personalize this simulation with your numbers, representing Sam, and see the results over time</p>
                    
                </div>
                <Link data-aos="zoom-in" to={'/personalize-simulation/number-of-rental-property'} 
                    className="btn btn-warning btn-lg px-5 border-3 border-white fw-bold inner-shadow w-50 mt-2">
                    Let’s Go!
                </Link>
            </div>
        </div>
      </div>
    </>
  );
}

export default PersonalizeSimulationHome;
